import type { HTMLAttributes } from "react";
import { tv, type VariantProps } from "tailwind-variants";

const badge = tv({
  base: "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs leading-4 font-medium",
  variants: {
    tone: {
      default: "bg-surface-hovered text-text",
      info: "bg-info-background text-[#0e4d6f]",
      success: "bg-success-background text-success",
      warning: "bg-warning-background text-warning",
      critical: "bg-destructive-background text-destructive",
      new: "bg-primary-subdued text-primary",
    },
  },
  defaultVariants: {
    tone: "default",
  },
});

type Props = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badge>;

export const Badge: React.FC<Props> = ({
  tone,
  className,
  children,
  ...props
}) => {
  return (
    <span className={badge({ tone, className })} {...props}>
      {children}
    </span>
  );
};
